import { cn } from '@/lib/cn';
import { compact } from '@/lib/format';

interface StatsRowProps {
  views?: number;
  comments?: number;
  likes?: number;
  dislikes?: number;
  className?: string;
}

/**
 * 게시글 통계 행 — 라벨+숫자 구조, 각 항목 min-width 고정으로 레이아웃 안정화
 */
export function StatsRow({ views, comments, likes, dislikes, className }: StatsRowProps) {
  return (
    <div className={cn('flex items-center gap-3 text-xs text-[var(--color-text-sub)]', className)}>
      {views !== undefined && (
        <span className="inline-flex items-center gap-1" style={{ minWidth: 64 }}>
          <span>조회수</span>
          <span className="tabular-nums">{compact(views)}</span>
        </span>
      )}
      {comments !== undefined && (
        <span className="inline-flex items-center gap-1" style={{ minWidth: 60 }}>
          <span>댓글수</span>
          <span className="tabular-nums">{compact(comments)}</span>
        </span>
      )}
      {likes !== undefined && (
        <span
          className="inline-flex items-center gap-1 text-[var(--color-rise)]"
          style={{ minWidth: 48 }}
        >
          <span>추천</span>
          <span className="tabular-nums">{compact(likes)}</span>
        </span>
      )}
      {dislikes !== undefined && (
        <span
          className="inline-flex items-center gap-1 text-[var(--color-fall)]"
          style={{ minWidth: 56 }}
        >
          <span>비추천</span>
          <span className="tabular-nums">{compact(dislikes)}</span>
        </span>
      )}
    </div>
  );
}
